"use strict";

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("@loadable/component"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Burger = _interopRequireDefault(require("../../Icons/Burger"));

var _TouchableOpacity = _interopRequireDefault(require("../../TouchableOpacity"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Menu = (0, _component["default"])(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2["default"])(require('./Menu'));
  });
});

var Fallback = function Fallback() {
  var t = (0, _useTranslation["default"])();
  return (0, _core.jsx)(_TouchableOpacity["default"], {
    "aria-label": t('open_menu'),
    disabled: true
  }, (0, _core.jsx)(_Icon["default"], {
    as: _Burger["default"],
    color: "primary",
    size: 8
  }));
};

__signature__(Fallback, "useTranslation{t}", function () {
  return [_useTranslation["default"]];
});

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      breakpoint = _useTheme.breakpoint,
      spacing = _useTheme.spacing;

  return {
    root: (0, _defineProperty2["default"])({
      height: spacing(7),
      alignItems: 'center',
      display: 'flex'
    }, breakpoint.up('lg'), {
      display: 'none'
    })
  };
};

__signature__(useStyles, "useTheme{{ breakpoint, spacing }}", function () {
  return [_useTheme2["default"]];
});

var Mobile = function Mobile(props) {
  var classes = useStyles();
  return (0, _core.jsx)(_Flex["default"], {
    css: classes.root,
    width: "100%",
    padding: [0, 2]
  }, (0, _core.jsx)(Menu, (0, _extends2["default"])({
    fallback: (0, _core.jsx)(Fallback, null)
  }, props)));
};

__signature__(Mobile, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Mobile;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Menu, "Menu", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/index.tsx");
  reactHotLoader.register(Fallback, "Fallback", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/index.tsx");
  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/index.tsx");
  reactHotLoader.register(Mobile, "Mobile", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();